import React from "react";

import { Value } from "lib/build/schema";

import { api } from "src/common/utils/api";
import { useCreateGenericError } from "src/features/notifications";

interface Payload {
	password: string;
}

export function useResetPassword(
	token: string,
	value: Value,
	isValid: boolean
): { isSubmitted: boolean; isLoading: boolean; onSubmit(): void } {
	const createGenericError = useCreateGenericError();

	const [isSubmitted, setSubmitted] = React.useState(false);
	const [isLoading, setLoading] = React.useState(false);

	const valueRef = React.useRef(value);
	React.useEffect(() => {
		valueRef.current = value;
	}, [value]);

	const isValidRef = React.useRef(isValid);
	React.useEffect(() => {
		isValidRef.current = isValid;
	}, [isValid]);

	const resetPassword = React.useCallback(
		async ({ password }: Payload) => {
			setLoading(true);
			try {
				await api.post("/authflow/resetpassword", {
					token,
					newPassword: password
				});
				setLoading(false);
				redirectToSignIn();
			} catch {
				setLoading(false);
				createGenericError();
			}
		},
		[token, createGenericError]
	);

	const onSubmit = React.useCallback((): void => {
		setSubmitted(true);
		if (isValidRef.current) {
			resetPassword(valueRef.current);
		}
	}, [resetPassword]);

	return { isSubmitted, isLoading, onSubmit };
}

function redirectToSignIn(): void {
	window.location.href = "/sign-in";
}
